define("command-palette/components/command-palette/provider/index", ["exports", "@ember/component", "@ember/debug", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "@glimmer/tracking", "command-palette/constants", "lodash", "@ember/template-factory"], function (_exports, _component, _debug, _object, _runloop, _service, _component2, _tracking, _constants, _lodash, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"command-palette/constants",0,"lodash",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.isOpen}}
    <div class="command-palette">
      {{yield
        (hash
          commands=this.commands
          empty=this.isEmpty
          key=this.key
          modifierKey=this.modifierKey
          query=this.parsedQuery
          rawQuery=this.query
          searching=this.isSearching
          searchResults=this.allSearchResults
          selectedIndex=this.selectedResultIndex
        )
        (hash
          close=this.close execute=this.execute open=this.open search=this.search select=this.select toggle=this.toggle
        )
      }}
    </div>
  {{/if}}
  */
  {
    "id": "eTS2Szh5",
    "block": "[[[41,[30,0,[\"isOpen\"]],[[[1,\"  \"],[10,0],[14,0,\"command-palette\"],[12],[1,\"\\n    \"],[18,1,[[28,[37,2],null,[[\"commands\",\"empty\",\"key\",\"modifierKey\",\"query\",\"rawQuery\",\"searching\",\"searchResults\",\"selectedIndex\"],[[30,0,[\"commands\"]],[30,0,[\"isEmpty\"]],[30,0,[\"key\"]],[30,0,[\"modifierKey\"]],[30,0,[\"parsedQuery\"]],[30,0,[\"query\"]],[30,0,[\"isSearching\"]],[30,0,[\"allSearchResults\"]],[30,0,[\"selectedResultIndex\"]]]]],[28,[37,2],null,[[\"close\",\"execute\",\"open\",\"search\",\"select\",\"toggle\"],[[30,0,[\"close\"]],[30,0,[\"execute\"]],[30,0,[\"open\"]],[30,0,[\"search\"]],[30,0,[\"select\"]],[30,0,[\"toggle\"]]]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"&default\"],false,[\"if\",\"yield\",\"hash\"]]",
    "moduleName": "command-palette/components/command-palette/provider/index.hbs",
    "isStrictMode": false
  });
  /**
   * TODO: can we move this into a configuration argument?
   */
  const RESULT_LIST_ITEM_SELECTOR = 'li.h--globalSearch__resultItem button';
  const MAX_PREVIOUSLY_USED_RESULTS = 2;
  let CommandPaletteProviderComponent = _exports.default = (_class = class CommandPaletteProviderComponent extends _component2.default {
    get isEmpty() {
      return this.searchResults.length === 0 && this.query.length > 2 && !this.isSearching;
    }
    get isOpen() {
      return this.commandPalette.isOpen;
    }
    get isSearching() {
      return this.searching;
    }
    get parsedQuery() {
      return this.commandPalette.parseQuery(this.query);
    }
    get commands() {
      return this.commandPalette.commands;
    }
    get key() {
      return this.args.key;
    }
    get modifierKey() {
      return this.args.modifierKey;
    }
    get allSearchResults() {
      if (this.searchResults.length !== 0) {
        return this.searchResults;
      }
      const combinedResults = [...this.previousResults, ...this.suggestedResults];
      const descriptions = new Set();
      const filteredResults = combinedResults.filter(result => {
        if (!descriptions.has(result.description)) {
          descriptions.add(result.description);
          return true;
        }
        return false;
      });
      return filteredResults;
    }
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "commandPalette", _descriptor, this);
      _initializerDefineProperty(this, "query", _descriptor2, this);
      _initializerDefineProperty(this, "searching", _descriptor3, this);
      _initializerDefineProperty(this, "searchResults", _descriptor4, this);
      _initializerDefineProperty(this, "previousResults", _descriptor5, this);
      _initializerDefineProperty(this, "suggestedResults", _descriptor6, this);
      _initializerDefineProperty(this, "selectedResultIndex", _descriptor7, this);
      _defineProperty(this, "onKeyDown", this.handleKeyEvent.bind(this));
      (false && !(!!this.args.modifierKey) && (0, _debug.assert)('A `modifierKey` argument must be provided', !!this.args.modifierKey));
      (false && !(!!this.args.key) && (0, _debug.assert)('A `key` argument must be provided', !!this.args.key));
      (false && !(!this.args.cache || !!this.args.cache && Boolean(this.args.cache.save) && Boolean(this.args.cache.load)) && (0, _debug.assert)('The optional `cache` argument requires a `save` and `load` function if provided', !this.args.cache || !!this.args.cache && Boolean(this.args.cache.save) && Boolean(this.args.cache.load)));
      this.load();
      document.addEventListener('keydown', this.onKeyDown);
    }
    willDestroy() {
      document.removeEventListener('keydown', this.onKeyDown);
      super.willDestroy();
    }
    open() {
      this.setup();
      if ((0, _lodash.isFunction)(this.args.beforeOpen)) this.args.beforeOpen();
      this.commandPalette.openSearchModal();
      if ((0, _lodash.isFunction)(this.args.afterOpen)) this.args.afterOpen();
    }
    close() {
      this.reset();
      if ((0, _lodash.isFunction)(this.args.beforeClose)) this.args.beforeClose();
      this.commandPalette.closeSearchModal();
      if ((0, _lodash.isFunction)(this.args.afterClose)) this.args.afterClose();
    }
    async toggle() {
      if (this.isOpen) {
        return this.close();
      }
      return this.open();
    }
    async search(query) {
      this.searching = true;
      this.query = query;
      try {
        const parsedQuery = this.commandPalette.parseQuery(this.query);
        const searchResults = await this.commandPalette.search(parsedQuery);
        this.handleSearchResults(searchResults);
      } catch (error) {
        // TODO
      } finally {
        this.searching = false;
      }
    }
    async execute(result) {
      let query = this.commandPalette.parseQuery(this.query);
      if (result.type === _constants.SearchCommandResultType.PreviouslyUsed && result.query) {
        ({
          query
        } = result);
      }
      this.commandPalette.runCommand(result.commandId, query);
      this.addSearchResultToPreviouslyUsed(result, query);
      this.close();
    }
    select(index) {
      this.setSelectedResultIndex(index);
    }
    scrollTo(elementSelector, blockPosition) {
      const results = document.querySelectorAll(elementSelector);
      if (results.length === 0) {
        return;
      }
      const currentItem = results[this.selectedResultIndex];
      currentItem?.scrollIntoView({
        behavior: 'smooth',
        block: blockPosition,
        inline: 'nearest'
      });
    }
    setup() {
      if (this.searchResults.length > 0) {
        this.setSelectedResultIndex(0);
      }
      this.suggestedResults = this.commandPalette.getSuggestedSearchResults();
    }
    reset() {
      (0, _runloop.next)(() => {
        this.searchResults.clear();
        this.query = '';
      });
      this.setSelectedResultIndex(-1);
    }
    handleKeyEvent(event) {
      if (this.handleShortcut(event)) return;
      if (this.handleUpArrow(event)) return;
      if (this.handleDownArrow(event)) return;
      if (this.handleEnter(event)) return;
    }
    handleShortcut(event) {
      if (event.key.toLocaleLowerCase() === this.args.key.toLocaleLowerCase() && event[this.args.modifierKey]) {
        event.preventDefault();
        this.toggle();
        return true;
      }
      return false;
    }
    handleUpArrow(event) {
      if (event.key !== 'ArrowUp') {
        return false;
      }
      if (document.activeElement?.tagName !== 'INPUT') {
        return true;
      }
      event.preventDefault();
      if (this.selectedResultIndex < 0) {
        return true;
      }
      if (this.selectedResultIndex === 0) {
        this.select(this.searchResults.length - 1);
        this.scrollTo(RESULT_LIST_ITEM_SELECTOR, 'end');
        return true;
      }
      this.select(this.selectedResultIndex - 1);
      this.scrollTo(RESULT_LIST_ITEM_SELECTOR, 'start');
      return true;
    }
    handleDownArrow(event) {
      if (event.key !== 'ArrowDown') {
        return false;
      }
      if (document.activeElement?.tagName !== 'INPUT') {
        return true;
      }
      event.preventDefault();
      if (this.selectedResultIndex === this.searchResults.length - 1) {
        this.select(0);
        this.scrollTo(RESULT_LIST_ITEM_SELECTOR, 'start');
        return true;
      }
      this.select(this.selectedResultIndex + 1);
      this.scrollTo(RESULT_LIST_ITEM_SELECTOR, 'end');
      return true;
    }
    handleEnter(event) {
      if (event.key !== 'Enter') {
        return false;
      }
      if (this.selectedResultIndex < 0) {
        return true;
      }
      if (document.activeElement?.tagName !== 'INPUT') {
        return true;
      }
      const result = this.allSearchResults[this.selectedResultIndex];
      if (result) {
        this.execute(result);
      }
      return true;
    }
    handleSearchResults(searchResults) {
      this.searchResults = searchResults;
      if (this.searchResults.length === 0) {
        this.setSelectedResultIndex(-1);
        return;
      }

      // Note: Reset the selected result index to 0 when the search results change
      this.setSelectedResultIndex(0);
    }
    setSelectedResultIndex(index) {
      (0, _runloop.next)(() => {
        this.selectedResultIndex = index;
      });
    }
    addSearchResultToPreviouslyUsed(result, query) {
      const newResult = {
        ...result,
        type: _constants.SearchCommandResultType.PreviouslyUsed,
        query
      };
      const combinedResults = [newResult, ...this.previousResults];
      const descriptions = new Set();
      this.previousResults = combinedResults.filter(result => {
        if (!descriptions.has(result.description)) {
          descriptions.add(result.description);
          return true;
        }
        return false;
      }).slice(0, MAX_PREVIOUSLY_USED_RESULTS);
      this.save();
    }
    load() {
      if (!this.args.cache) {
        return;
      }
      const loaded = this.args.cache.load('previouslyUsedSearchResults');
      this.previousResults = loaded.reduce((acc, searchResult) => {
        const command = this.commands.find(command => searchResult.commandId === command.commandId);
        if (command) {
          acc.push({
            commandId: command.commandId,
            description: command.getDescription(searchResult.query),
            icon: command.getIcon(searchResult.query),
            title: command.getTitle(searchResult.query),
            query: searchResult.query,
            score: searchResult.score,
            type: searchResult.type
          });
        }
        return acc;
      }, []);
    }
    save() {
      if (this.args.cache) {
        this.args.cache.save('previouslyUsedSearchResults', this.previousResults);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "commandPalette", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "query", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "searching", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "searchResults", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "previousResults", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "suggestedResults", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedResultIndex", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return -1;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "open", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggle", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "search", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "search"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "execute", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "execute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "select", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "select"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollTo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "scrollTo"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CommandPaletteProviderComponent);
});